module.exports = __webpack_public_path__ + "assets/img/freespins.14a0dbcb.svg";